import { ResultPagDTO } from '@/interfaces/base-dto';
import { BloqueioDesbloqueioParmDTO, EnderecoEntregaFiltroParmDTO } from '@/interfaces/delivery-address';
import { ENDPOINTS } from '@/settings/api-settings';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from './api';

export function findDeliveryAddress(filtro: EnderecoEntregaFiltroParmDTO): Observable<ResultPagDTO<any>> {
  return from(apiClient.get(ENDPOINTS.DELIVERY_ADDRESS, filtro)).pipe(map((r: any) => (!!r.data ? r.data : [])));
}

export function blockDeliveryAddress(parm: BloqueioDesbloqueioParmDTO): Observable<any> {
  return from(apiClient.put(ENDPOINTS.DELIVERY_ADDRESS_BLOCK, parm)).pipe(map((r: any) => (!!r.data ? r.data : [])));
}

export function unblockDeliveryAddress(parm: BloqueioDesbloqueioParmDTO): Observable<any> {
  return from(apiClient.put(ENDPOINTS.DELIVERY_ADDRESS_UNBLOCK, parm)).pipe(map((r: any) => (!!r.data ? r.data : [])));
}

export function listDeliveryAddressHist(ids: string): Observable<any> {
  return from(apiClient.get(ENDPOINTS.DELIVERY_ADDRESS_HIST.replace("{ids}", encodeURI(ids)))).pipe(map((r: any) => (!!r.data ? r.data : [])));
}

